import $ from 'jquery';

export default class blogDraggable {
    constructor() {
        $('#blog__categories-scroll').on('click', function () {
            var scroll_width = $('#blog__wrapper-categories').width();
            var scroll_margin = parseInt($('#blog__wrapper-categories').css('margin-left'));
            var last_offset = $('#blog__wrapper-categories a').last().offset();
            if(last_offset.left > 1040){
                $('#blog__wrapper-categories').animate({marginLeft: '-=100px'}, 0);
            }
            else{
                $('#blog__wrapper-categories').animate({marginLeft: '0px'}, 0);
            }
        });
    }
}
